import { readonly, ref, useContext } from '@nuxtjs/composition-api';

import { ComposableFunctionArgs, Countries } from '~/composables/types';
import { getItem, setItem } from '~/helpers/asyncLocalStorage';
import { Logger } from '~/helpers/logger';
import { Country, CountryInformationQuery, Maybe } from '~/modules/GraphQL/types';

import { UseCountrySearchInterface } from './useCountrySearch';

/**
 * Allows fetching a list of countries or a single country by ID
 *
 * See the {@link UseCountrySearchInterface} for a list of methods and values available in this composable.
 */
export function useCountrySearch(): UseCountrySearchInterface {
  const { app } = useContext();
  const loading = ref(false);
  const error = ref({
    search: null,
    load: null,
  });

  const search = async (params: ComposableFunctionArgs<{ id: string }>): Promise<Maybe<Country>> => {
    let results = null;

    try {
      loading.value = true;

      Logger.debug('[Magento]: Search country information based on', { params });

      // const localCountryCodeObj = await getItem(`${params.id}-country-info`) as CountryInformationQuery;
      // if (localCountryCodeObj && localCountryCodeObj.country) {
      //   Logger.debug('[Find localCountryCodeObj]:', localCountryCodeObj);
      //   results = localCountryCodeObj?.country ?? null;
      //   error.value.search = null;
      // } else {
      //   const { data } = await app.$vsf.$magento.api.country(params.id, params?.customQuery ?? null, params?.customHeaders ?? null);

      //   Logger.debug('[Search country information Result]:', { data });

      //   results = data?.country ?? null;
      //   error.value.search = null;
      //   await setItem(`${params.id}-country-info`, data);
      // }
      const { data } = await app.$vsf.$magento.api.country(params.id, params?.customQuery ?? null, params?.customHeaders ?? null);

      Logger.debug('[Search country information Result]:', { data });

      results = data?.country ?? null;
      error.value.search = null;
    } catch (err) {
      error.value.search = err;
      Logger.error('useCountrySearch/search', err);
    } finally {
      loading.value = false;
    }

    return results;
  };

  const load = async (): Promise<Array<Countries>> => {
    let results = [];

    try {
      loading.value = true;

      Logger.debug('[Magento]: Load available countries on store');

      const { data } = await app.$vsf.$magento.api.countries();

      Logger.debug('[Result]:', { data });

      results = data?.countries ?? [];
      error.value.search = null;
    } catch (err) {
      error.value.search = err;
      Logger.error('useCountrySearch/load', err);
    } finally {
      loading.value = false;
    }

    return results;
  };

  return {
    load,
    search,
    loading: readonly(loading),
    error: readonly(error),
  };
}

export * from './useCountrySearch';
export default useCountrySearch;
